import * as React from "react"

import Link from "../Link"

interface Props {
    attributes: Record<string, string>
    label: string
    personId: string
}

export const PersonDetail = ({
    attributes,
    label,
    personId,
}: Props): JSX.Element => {
    const href = `config/persons/${personId}`

    return <Link attributes={attributes} label={label} href={href} />
}

export default PersonDetail
